import { useContext, useEffect } from 'react';
import { AText, Box, Button } from '@alf/uikit';
import { OTHER_BONUS_TYPES, useGetBonusesCounters } from '@namespace/bonuses';
import { useGeneralRoutes } from '@namespace/cms';
import { LocalizedLink, useI18n } from '@namespace/i18n';
import { useRouteParams } from '@namespace/router';
import { UserContext } from '@namespace/user';
import {
  ALL_TYPES_BONUSES_COUNT,
  BONUSES_SECTION_ACTIVE,
  BONUSES_SECTION_AVAILABLE
} from '../../../../constants';

import styles from './index.module.css';

export const BonusesSectionToggle = ({ normalizedPromoTabs }) => {
  const isDisplayCounter = normalizedPromoTabs.bonuses?.showCounterActive;
  const [user] = useContext(UserContext);
  const { counters } = user;
  const bonusesCount = counters[ALL_TYPES_BONUSES_COUNT];
  const { promotions: promotionsPath } = useGeneralRoutes();
  const { t } = useI18n();
  const { tag: tagPath } = useRouteParams(`${promotionsPath}/:category/:tag`);
  const fetchBonusCounter = useGetBonusesCounters([
    OTHER_BONUS_TYPES.ALL_TYPES_BONUSES
  ]);

  useEffect(() => {
    if (tagPath === BONUSES_SECTION_ACTIVE && isDisplayCounter) {
      fetchBonusCounter();
    }
  }, [isDisplayCounter, tagPath]);

  return (
    <Box className={styles.container}>
      {[BONUSES_SECTION_AVAILABLE, BONUSES_SECTION_ACTIVE].map(
        (bonusSection) => {
          const isActive = bonusSection === tagPath;

          return (
            <Button
              key={bonusSection}
              component={LocalizedLink}
              to={`${promotionsPath}/bonuses/${bonusSection}`}
              className={styles.button}
              intent={isActive ? 'primary' : 'quaternary'}
              size="m"
              actionType="color3"
            >
              {t(`web.bonuses.${bonusSection}.title`)}
              {bonusSection === BONUSES_SECTION_ACTIVE &&
                isDisplayCounter &&
                bonusesCount > 0 && (
                  <Box
                    align="center"
                    justify="center"
                    className={styles.counterContainer}
                  >
                    <AText breed="R" color="po_txt_color_2" size="xs">
                      {bonusesCount}
                    </AText>
                  </Box>
                )}
            </Button>
          );
        }
      )}
    </Box>
  );
};
